
    <div class="createdfolder">
      <div class="drive mainLink">
       
        <div class="folderName" (click)="showInbox()" [routerLink]="'/esignature/inbox'" [routerLinkActive]="['active']">
          <mat-icon class="type">inbox</mat-icon> Inbox
          <span class="ttl" *ngIf="totalInbox > 0">{{totalInbox}}</span>
        </div>

        <div class="folderName" (click)="showSent()" [routerLink]="'/esignature/sent'" [routerLinkActive]="['active']">
          <mat-icon class="type">send</mat-icon> Projects
        </div>

        <div class="folderName" (click)="showDraft()" [routerLink]="'/esignature/draft'" [routerLinkActive]="['active']">
          <mat-icon class="type">drafts</mat-icon> Draft
        </div>
             
        <div class="folderName" (click)="showTrash()" [routerLink]="'/esignature/trash'" [routerLinkActive]="['active']">
          <mat-icon class="type">restore_from_trash</mat-icon> Trash
        </div>

        <ng-container *ngIf="showLocalPanel">
          <div class="folderName" [routerLink]="'/esignature/favourite'" [routerLinkActive]="['active']">
            <mat-icon class="type">star_rate</mat-icon> Starred
          </div>
        </ng-container>
     

        <div class="sepreator"></div>


        <div class="customDropDown" [routerLink]="'/esignature/'" [ngClass]="{ 'active': Formsactive }" >

          <button mat-icon-button class="arrowIcon" (click)="showFormsToggle()">
            <mat-icon *ngIf="showForms">arrow_drop_down</mat-icon>
            <mat-icon *ngIf="!showForms">arrow_right</mat-icon>
          </button>
          
          <div class="folderName" (click)="getLeftMenuList()">
            <mat-icon class="type">account_balance</mat-icon> Forms
            <button mat-icon-button class="createNew" color="primary" (click)="createNewFolder()">
              <mat-icon>create_new_folder</mat-icon>
            </button>
          </div>
        </div>

        <div class="allfolders">

        <ng-container *ngIf="showForms">
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
         
            <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderID }" *matTreeNodeDef="let node ; let indx = index"  matTreeNodePadding matTreeNodePaddingIndent="20">
            
              <div class="folderRow">
                <div class="folderName">
                  <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility:hidden">
                    arrow_drop_down
                  </mat-icon> 
                  <mat-icon class="folder" *ngIf="node.isShared == false" (click)="getFormFolderWithFormTemplates(node)">folder</mat-icon>
                  <mat-icon class="folder" *ngIf="node.isShared == true" (click)="getFormFolderWithFormTemplates(node)">folder_shared</mat-icon>
                  <span (click)="getFormFolderWithFormTemplates(node)">{{node.formFolderName}}</span>
  
                  <div class="flOpt">
                    <button mat-icon-button [matMenuTriggerFor]="menu" color="basic"><mat-icon>more_vert</mat-icon></button>
                    <mat-menu #menu="matMenu" xPosition="before">
                      <button mat-menu-item (click)="createFolders(node)"><mat-icon>create_new_folder</mat-icon> Create Folder</button> 
                      <button mat-menu-item (click)="getFormFolderWithFormTemplates(node)"><mat-icon>folder_open</mat-icon> Open</button>

                      <ng-container *ngIf="node.formFolderName != 'My Forms'">
                        <!-- <button mat-menu-item *ngIf="showLocalPanel" [routerLink]="'/esignature/first'"><mat-icon>picture_as_pdf</mat-icon> Create Pdf Form  </button> -->
                        <!-- <button mat-menu-item [routerLink]="'/esignature/htmlcanvas'"><mat-icon>code</mat-icon> Create Html Form  </button> -->
                        <button mat-menu-item (click)="RenameFolders(node)"><mat-icon>format_size</mat-icon> Rename  </button>
                        <button mat-menu-item (click)="MoveTo(node)"><mat-icon>low_priority</mat-icon> Move to  </button>
                        <button mat-menu-item (click)="DeleteFolders(node)"><mat-icon>delete_outline</mat-icon> Delete</button>
                      </ng-container>
                    </mat-menu>
                  </div>
  
                </div>
              </div>
              
            </mat-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderID }"  *matTreeNodeDef="let node;when: hasChild ; let indx = index"  matTreeNodePadding matTreeNodePaddingIndent="20">
              <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.formFolderName">
                <mat-icon id="node-{{node.formFolderName}}" (click)="rememberNode($event.currentTarget.id,$event)" class="mat-icon-rtl-mirror arrowIcon">
                  {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
                </mat-icon>                
                <div class="folderName">
                  <mat-icon class="folder" *ngIf="node.isShared == false" (click)="getFormFolderWithFormTemplates(node)">folder</mat-icon>
                  <mat-icon class="folder" *ngIf="node.isShared == true" (click)="getFormFolderWithFormTemplates(node)">folder_shared</mat-icon>
                   <span  (click)="getFormFolderWithFormTemplates(node)" class="flname">{{node.formFolderName}}</span>
                </div>
                <div class="flOpt">
                  <button mat-icon-button [matMenuTriggerFor]="menu" color="basic"><mat-icon>more_vert</mat-icon></button>
                  <mat-menu #menu="matMenu" xPosition="before">
                    <button mat-menu-item (click)="createFolders(node)"><mat-icon >create_new_folder</mat-icon> Create Folder</button> 
                    <button mat-menu-item (click)="getFormFolderWithFormTemplates(node)"><mat-icon>folder_open</mat-icon> Open</button>  
                    
                    <ng-container *ngIf="node.formFolderName != 'My Forms'">
                    <!-- <button mat-menu-item [routerLink]="'/esignature/first'"><mat-icon>picture_as_pdf</mat-icon> Create PDF Form  </button>                     -->
                    <button mat-menu-item (click)="RenameFolders(node)"><mat-icon>format_size</mat-icon> Rename  </button>
                    <button mat-menu-item (click)="MoveTo(node)"><mat-icon>low_priority</mat-icon> Move to  </button>
                    <button mat-menu-item (click)="DeleteFolders(node)"><mat-icon>delete_outline</mat-icon> Delete</button>
                    </ng-container>
                    
                  </mat-menu>
                </div>
              </div>
              
            </mat-tree-node>
          </mat-tree>          
        </ng-container>

        </div>
       
        <div class="folderName" (click)="getSharedWithMe()" [routerLink]="'/esignature/'"  [ngClass]="{ 'active': SharedWithMeactive }">
                 
          <mat-icon class="type">share</mat-icon> Shared with me
         
        </div>
        

        <div class="folderName" (click)="templateGallery(template)">         
          <mat-icon class="type">backup_table</mat-icon> Template Gallery         
        </div>      

      </div>
          
    </div>


<ng-template #createFolder>
  <h2 matDialogTitle>Create Folder</h2>
  <mat-dialog-content>
    <mat-form-field class="example-full-width">
      <mat-label>Folder Name</mat-label>
      <input matInput  placeholder="Add folder name"
        value="" />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button  color="" >Close</button>
    <button mat-button  color="primary">
      Create
    </button>
  </mat-dialog-actions>
</ng-template>
  


<ng-template #template>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Template Gallery
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <!-- <mat-dialog-content>
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"
    (selectedTabChange)="getTabDetails($event)">

   <mat-tab label="Global">

    <div class="searchSelectCat">    
      <div class="selectCat">
        <br> 
        <mat-form-field appearance="fill">
          <mat-label>Select Category</mat-label>
          <mat-select [(value)]="selectedCategoryID" (selectionChange)="selectCategory($event,'global')">          
            <mat-option value="0">All</mat-option>
            <mat-option *ngFor="let cat of categoryList" [value]="cat.categoryID">
            {{ cat.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div> 


      <div class="search">
        <br> 
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search</mat-label>
          <input type="search" readonly matInput placeholder="search template">
        </mat-form-field>
      </div>  
    </div>

    <div class="tempalteList">
      <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFound">
        <tr>
          <th>Type</th>
          <th>Template Name</th> 
          <th>Category Name</th>        
          <th class="actBtn" >Action</th>
        </tr>
        <tr *ngFor="let temp of masterTemplateList">
          <td>
             <img *ngIf="temp.formType == 1" src="../../../../assets/images/icons/formIcon.svg" alt="" width="25"/>
            <img *ngIf="temp.formType == 2" src="../../../../assets/images/icons/form_tabuler.svg" alt="" width="25 "/>  
            <app-doc-icons *ngIf="temp.formType == 1" [iconType]="'FORM'"></app-doc-icons>
            <app-doc-icons *ngIf="temp.formType == 2" [iconType]="'TABULAR'"></app-doc-icons>
            <app-doc-icons *ngIf="temp.formType == 3" [iconType]="'HTML'"></app-doc-icons>
          </td>

          <td class="formName">
           {{temp.formName}}
          </td>

          <td>{{temp.categoryName}}</td>

          <td>
            <button *ngIf="temp.formType != 3" mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip" matTooltip="Create Project" 
            (click)="CreateProjectFromMasterTemplate(temp)"><mat-icon>post_add</mat-icon>
            </button>
            <button *ngIf="ShowGlobalTemplateDelete" mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip" matTooltip="Delete Template" 
            (click)="DeleteGlobalTemplate(temp)"><mat-icon>delete_outline</mat-icon>
            </button>
            <button mat-icon-button color="basic" (click)="MakeMasterCopyOfFormTemplate(temp)" mat-icon-button matTooltipClass="tooltip"
             matTooltip="Import Template"><mat-icon>swap_horiz</mat-icon>
            </button>
            <button *ngIf="ShowGlobalTemplateDelete" (click)="EditMasterTemplate(temp)" class="edit" mat-icon-button color="basic"
            mat-icon-button matTooltipClass="tooltip" matTooltip="Edit"><mat-icon>create</mat-icon>
           </button>
          </td>
        </tr>
      </table>
      <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>
    </div>
   </mat-tab>
  
   <mat-tab label="Organization">

    <div class="searchSelectCat">      
      <div class="selectCat">
        <br> 
        <mat-form-field appearance="fill">
          <mat-label>Select Category</mat-label>
          <mat-select (selectionChange)="selectCategory($event,'Organization')">          
            <mat-option value="0">All</mat-option>
            <mat-option *ngFor="let cat of categoryList" [value]="cat.categoryID">
            {{ cat.name }}
            </mat-option>
          </mat-select>
          <mat-select [(value)]="selectedCategoryID" (selectionChange)="selectCategory($event,'Organization')">          
            <mat-option value="0">All</mat-option>
            <mat-option *ngFor="let cat of categoryList" [value]="cat.categoryID">
            {{ cat.name }}
            </mat-option>
          </mat-select> 
        </mat-form-field>
      </div> 


      <div class="search">
        <br> 
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search</mat-label>
          <input type="search" readonly matInput placeholder="search template">
        </mat-form-field>
      </div>  
    </div>

    <div class="tempalteList">
      <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFound">
        <tr>
          <th>Type</th>
          <th>Template Name</th> 
          <th>Category Name</th>        
          <th class="actBtn">Action</th>
        </tr>
        <tr *ngFor="let temp of OrganizationTemplateList">
          <td>
       
            <app-doc-icons *ngIf="temp.formType == 1" [iconType]="'FORM'"></app-doc-icons>
            <app-doc-icons *ngIf="temp.formType == 2" [iconType]="'TABULAR'"></app-doc-icons>
            <app-doc-icons *ngIf="temp.formType == 3" [iconType]="'HTML'"></app-doc-icons>
          </td>

          <td class="formName">
           {{temp.formName}}
          </td>

          <td>{{temp.categoryName}}</td>

          <td>
            <button *ngIf="temp.formType != 3" mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip" matTooltip="Create Project" 
            (click)="CreateProjectFromMasterTemplate(temp)"><mat-icon>post_add</mat-icon>
            </button>
            
            <button *ngIf="ShowGlobalTemplateDelete" mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip" matTooltip="Delete Template" 
            (click)="DeleteOrganizationTemplate(temp)"><mat-icon>delete_outline</mat-icon>
            </button>
           

            <button mat-icon-button color="basic" (click)="MakeMasterCopyOfFormTemplate(temp)" mat-icon-button matTooltipClass="tooltip"
             matTooltip="Import Template"><mat-icon>swap_horiz</mat-icon>
            </button>
            <button *ngIf="ShowMasterTemplate" (click)="EditOrganizationMasterTemplate(temp)" class="edit" mat-icon-button color="basic"
            mat-icon-button matTooltipClass="tooltip" matTooltip="Edit"><mat-icon>create</mat-icon>
           </button>

           

          </td>
        </tr>
      </table>
      <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>
    </div>
   </mat-tab>

  </mat-tab-group> 

  </mat-dialog-content>  -->

  <div class="template-holder">
    <div class="left">

      <mat-form-field appearance="fill">
        <mat-label>Select Category</mat-label>
        <mat-select (selectionChange)="getTabDetails($event)" value="Global" >
          <mat-option value="Global">Global</mat-option>
          <mat-option value="Organization">Organization</mat-option>
        </mat-select>
      </mat-form-field>


      <div class="list">

        <ul>
          <li (click)="selectCategory(0,currentTaskTemplateTab, 0)"  [ngClass]="{'active': currentTemplateIndex == 0 }" >All</li>
          <ng-container  *ngFor="let cat of categoryList; let i = index">
            <li (click)="selectCategory(cat.categoryID,currentTaskTemplateTab, i+1)"   [ngClass]="{'active': currentTemplateIndex == i+1 }">{{ cat.name }}</li>
          </ng-container>           
        </ul>
      </div>
 
    </div>

    <div class="right">      
      <div class="search">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search</mat-label>
          <input type="search"  matInput placeholder="search template"
          (input)="searchTemplate($event.target.value)">
        </mat-form-field>
      </div> 

      <div class="list">
        <div class="tempalteList">
          <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFound">
            <tr>
              <th>Type</th>
              <th>Template Name</th> 
              <th>Category Name</th>        
              <th class="actBtn" >Action</th>
            </tr>
            <tr *ngFor="let temp of masterTemplateList">
              <td>
                <!-- <img *ngIf="temp.formType == 1" src="../../../../assets/images/icons/formIcon.svg" alt="" width="25"/>
                <img *ngIf="temp.formType == 2" src="../../../../assets/images/icons/form_tabuler.svg" alt="" width="25 "/>  -->
                <app-doc-icons *ngIf="temp.formType == 1" [iconType]="'FORM'"></app-doc-icons>
                <app-doc-icons *ngIf="temp.formType == 2" [iconType]="'TABULAR'"></app-doc-icons>
                <app-doc-icons *ngIf="temp.formType == 3" [iconType]="'HTML'"></app-doc-icons>
              </td>
    
              <td class="formName">
               {{temp.formName}}
              </td>
    
              <td>{{temp.categoryName}}</td>
    
              <td>
                <button *ngIf="temp.formType != 3" mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip" matTooltip="Create Project" 
                (click)="CreateProjectFromMasterTemplate(temp)"><mat-icon>post_add</mat-icon>
                </button>
                <button *ngIf="ShowGlobalTemplateDelete" mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip" matTooltip="Delete Template" 
                (click)="DeleteGlobalTemplate(temp)"><mat-icon>delete_outline</mat-icon>
                </button>
                <button mat-icon-button color="basic" (click)="CopyAFormFromAOffice(temp)" mat-icon-button matTooltipClass="tooltip"
                 matTooltip="Import Template"><mat-icon>swap_horiz</mat-icon>
                </button>
                <button *ngIf="ShowGlobalTemplateDelete" (click)="EditMasterTemplate(temp)" class="edit" mat-icon-button color="basic"
                mat-icon-button matTooltipClass="tooltip" matTooltip="Edit Template"><mat-icon>create</mat-icon>
               </button>
              </td>
            </tr>
          </table>
          <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>
        </div>
      </div>
        
         
        
    </div>

  </div>


 
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button  color="" (click)="close()">Close</button>   
  </mat-dialog-actions>
</ng-template>


<app-loader></app-loader>